
import {
  get_ELD_chart_colors,
} from "../../Utils/fp_metrics.js";
import { trainingAPI } from '../../api/TrainingAPI';
import { chartExportableOptions, getSuffixByStat } from "../mapperUtil"
import { drilldownPlayerLabel } from '../drilldownPlayerLabel.js';
import { healthyMax, healthyMean, healthyMin, healthySum, isInjured } from '../../Utils/injury.mjs';
export function mapMovementSignatureForHighcharts(
  {
    data, 
    mapping, 
    teamColors, 
    teamName, 
    showHamburger = true,
    stat = '',
    position = [], 
    player_group = [], 
    sessions = [], 
    enableDrillDown = false,
    playerId = null
  }
) {

  if(!data) return
  const injuredInGroup = playerId ? () => false : isInjured;
  const ELD_colors = get_ELD_chart_colors(teamName);
  const categories = data.map(item => item.disp_date);

  const series = [
    {
      name: mapping.bar1.metric_name,
      type: 'column',
      yAxis: 0,
      data: data.map((item, dataIndex) => ({
        name: categories[dataIndex],
        y: item[`${mapping.bar1.metric_name}__avg`] || 0,
        color: ELD_colors.bar[0],
        ...(enableDrillDown && {drilldown: `${mapping.bar1.metric_name}`})
      })),
      color: ELD_colors.bar[0]
    },
    {
      name: mapping.bar2.metric_name,
      type: 'column',
      yAxis: 0,
      data: data.map((item, dataIndex) => ({
        name: categories[dataIndex],
        y: item[`${mapping.bar2.metric_name}__avg`] || 0,
        color: ELD_colors.bar[1],
        ...(enableDrillDown && {drilldown: `${mapping.bar2.metric_name}`})
      })),
      color:  ELD_colors.bar[1]
    },
    {
      name: mapping.bar3.metric_name,
      type: 'column',
      yAxis: 0,
      data: data.map((item, dataIndex) => ({
        name: categories[dataIndex],
        y: item[`${mapping.bar3.metric_name}__avg`] || 0,
        color: ELD_colors.bar[2],
        ...(enableDrillDown && {drilldown: `${mapping.bar3.metric_name}`})
      })),
      color:  ELD_colors.bar[2]
    },
    {
      name: mapping.line.metric_name,
      type: 'spline',
      yAxis: 1,
      data: data.map((item, dataIndex) => ({
        name: categories[dataIndex],
        y: item[`${mapping.line.metric_name}__avg`] || 0,
        color: '#000000',
        ...(enableDrillDown && {drilldown: `${mapping.line.metric_name}`})
      })),
      color: '#000000',
      marker: {
        lineWidth: 2,
        lineColor: '#000000',
        fillColor: '#FFFFFF'
      },
      dataLabels: {
        enabled: false
      }
    }
  ];

  const showLeftYAxisLabels = mapping.bar1?.metric_name.includes("(T Score)");
  let positionsArray = [], playerNamesArray = [], lastProcessedDrillUpLevel = null;
  const options = {
    chart: {
      type: 'column',
      events: {
        load: function() {
          this.isDrilling = false;
          this.options.custom = this.options.custom || {};
          this.drilldownLevel = undefined;
          this.options.custom.title = 'Movement Signature vs Jump Height';
        },
        drilldown: function(e) {
          if (this.isDrilling) return;
          this.isDrilling = true;
          this.options.custom = this.options.custom || {};
          if (!e.seriesOptions) {
            const chart = this;
            const date = data[e.point.index]?.date;
            const index = e.point.index;

            if (!chart.drilldownLevel) {
              chart.drilldownLevel = 0;
            }

            if (chart.drilldownLevel >= 3) {
              return; 
            }

            if (!chart.drilldownData) {
              chart.showLoading('Loading data ...');
              trainingAPI.getDrillDownChartData({ 
                date,
                position,
                player_group,
                sessions,
                drilldown_type: 'movement-sig-forceplate',
                metric_id: [mapping.bar1.metric_id, mapping.bar2.metric_id, mapping.bar3.metric_id, mapping.line.metric_id],
                player_id: playerId || null
              })
                .then(response => {
                  const data = response.player_data;
                  const metrics = response.metrics;
                  chart.drilldownData = data;
                  const {drilldowns, positions} = createDrilldownStructure(chart.drilldownData, mapping, metrics, 
                                                                            e.point.name, enableDrillDown, 
                                                                            chart.drilldownLevel, stat);
                  positionsArray = [...positions];
                  const xAxis = chart.xAxis[0];
                  xAxis.categories = positions;
                  this.options.custom.currentCategories = positions;
                  this.options.custom.metrics = positions;
                  this.options.custom.drilldown = `${e.point.name}_positional_${stat}`;

                  chart.hideLoading();
                  chart.addSingleSeriesAsDrilldown(e.point, drilldowns[mapping?.bar1?.metric_name]);
                  chart.addSingleSeriesAsDrilldown(e.point, drilldowns[mapping?.bar2?.metric_name]);
                  chart.addSingleSeriesAsDrilldown(e.point, drilldowns[mapping?.bar3?.metric_name]);
                  chart.addSingleSeriesAsDrilldown(e.point, drilldowns[mapping?.line?.metric_name]);
                  chart.applyDrilldown()
                })
                .catch(error => {
                  console.error('Error fetching drill-down data:', error);
                  chart.hideLoading();
                })
                .finally(() => {
                  this.isDrilling = false;
                });
            } else {
              if (chart.drilldownLevel === 1 ) {
                try {
                  const {drilldowns, names} = createDrilldownStructure(chart.drilldownData, mapping, this.options.custom.metrics, 
                                                                            e.point.name, enableDrillDown, 
                                                                            chart.drilldownLevel + 1, stat);
                  const xAxis = chart.xAxis[0];
                  playerNamesArray = [...names];
                  xAxis.categories = names
                  this.options.custom.currentCategories = xAxis.categories;
                  this.options.custom.drilldown = `${e.point.name}_player_${stat}`;

                  chart.hideLoading();
                  chart.addSingleSeriesAsDrilldown(e.point, drilldowns[mapping?.bar1?.metric_name]);
                  chart.addSingleSeriesAsDrilldown(e.point, drilldowns[mapping?.bar2?.metric_name]);
                  chart.addSingleSeriesAsDrilldown(e.point, drilldowns[mapping?.bar3?.metric_name]);
                  chart.addSingleSeriesAsDrilldown(e.point, drilldowns[mapping?.line?.metric_name]);
                  chart.applyDrilldown()
                } catch(error){
                  console.error('Error occurred while setting drill-down level 2 data:', error);
                  chart.hideLoading();
                }
                finally{
                  this.isDrilling = false;
                }
              } else if (chart.drilldownLevel === 2 ) {
                try {
                  const {drilldowns, repNames} = createDrilldownStructure(chart.drilldownData, mapping, this.options.custom.metrics, 
                                                                            e.point.name, enableDrillDown, 
                                                                            chart.drilldownLevel + 1, stat);
                  const xAxis = chart.xAxis[0];
                  xAxis.categories = repNames
                  this.options.custom.currentCategories = xAxis.categories;
                  this.options.custom.drilldown = `${e.point.name}_player_reps_${stat}`;

                  chart.hideLoading();
                  chart.addSingleSeriesAsDrilldown(e.point, drilldowns[mapping?.bar1?.metric_name]);
                  chart.addSingleSeriesAsDrilldown(e.point, drilldowns[mapping?.bar2?.metric_name]);
                  chart.addSingleSeriesAsDrilldown(e.point, drilldowns[mapping?.bar3?.metric_name]);
                  chart.addSingleSeriesAsDrilldown(e.point, drilldowns[mapping?.line?.metric_name]);
                  chart.applyDrilldown()
                } catch(error){
                  console.error('Error occurred while setting drill-down level 3 data:', error);
                  chart.hideLoading();
                }
                finally{
                  this.isDrilling = false;
                }
              }
            }

            chart.drilldownLevel++;
            lastProcessedDrillUpLevel = chart.drilldownLevel;
          }
        },
        drillup: function(e) {
          const chart = this;
          const levelNum = e.seriesOptions._levelNumber;

          // Prevent duplicate drillup processing
          if (levelNum === lastProcessedDrillUpLevel || chart.isDrilling) return;

          lastProcessedDrillUpLevel = levelNum;
          chart.isDrilling = true;

          this.options.custom = this.options.custom || {};
          chart.drilldownLevel--;
          try{
            if (levelNum === 2) { 
              const xAxis = chart.xAxis[0];
              xAxis.categories = playerNamesArray;
              this.options.custom.currentCategories = playerNamesArray;
              this.options.custom.drilldown = `${e.seriesOptions.id}_player_${stat}`;
            }
            else if (levelNum === 1) { 
              const xAxis = chart.xAxis[0];
              xAxis.categories = positionsArray;
              this.options.custom.currentCategories = positionsArray;
              this.options.custom.drilldown = `${e.seriesOptions.id}_positional_${stat}`;

            } else if (levelNum === 0) {
              const chart = this;
              if (!chart) return;
              if (chart.drilldownData) {
                delete chart.drilldownData;
              }

              const xAxis = chart.xAxis?.[0];
              if (xAxis && Array.isArray(categories)) {
                xAxis.categories = categories;
                this.options.custom.currentCategories = categories;
                this.options.custom.drilldown = "";
              }
            }
          }
          catch(error){
            console.error(`Error occurred while drilling upwards for level ${levelNum} data:`, error);
            chart.hideLoading();
          } finally {
            this.isDrilling = false;
          }
        }
      }
    },
    title: {
      text: 'Movement Signature vs Jump Height'
    },
    xAxis: {
      categories: categories,
      crosshair: true,
      gridLineWidth: 1,
      gridLineColor: '#e6e6e6'
    },
    yAxis: [
      {
        title: {
          text: null
        },
        labels: {
          format: '{value}',
          enabled: showLeftYAxisLabels
        }
      },
      {
        title: {
          text: null
        },
        labels: {
          format: '{value}'
        },
        opposite: true,
        min: 0
      }
    ],
    tooltip: {
      shared: true
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      column: {
        grouping: true,
        shadow: false,
        borderWidth: 0,
        rotation: categories.length > 20 ? 270 : 0,
        dataLabels: {
          enabled: true,
          formatter: function() {
            return this.y;
          },
          style: {
            textOutline: '1px contrast'
          },
          inside: true,
          verticalAlign: 'middle'
        }
      },
      spline: {
        dataLabels: {
          enabled: false
        }
      }
    },
    series: series,
    drilldown: {
      allowPointDrilldown: false,
      activeAxisLabelStyle: {
        cursor: 'default',
        color: 'rgb(51, 51, 51)',
        textDecoration: 'none',
        fontWeight: 500,
        tickmarkPlacement: categories.length > 10 ? 'on' : 'between',
        tickWidth: 1
      },
      activeDataLabelStyle: {
        cursor: 'default',
        color: 'rgb(51, 51, 51)',
        textDecoration: 'none',
      },
      series: []
    },
    exporting: {
      enabled: showHamburger,
      ...chartExportableOptions
    }
  };

  function createDrilldownStructure(data, mapping, metrics, selectedPointName, enableDrillDown = false, levelNum, stat = 'Avg') {
    const drilldowns = {};
    const positions = [...new Set(data.map(item => item.player_id__position))];

    if (levelNum == 1) {
      // Second layer: Positions
      Object.entries(mapping).forEach(([seriesType, { metric_id, metric_name }], idx) => {
        const metric = metrics.filter(m => m.testing_metric_id === metric_id)[0];
        const decimal_places = metric?.num_decimals || 2;
        const suffix = getSuffixByStat(metric, stat);
        const isSeriesLine = (seriesType === "line");
        drilldowns[metric_name] = {
          name: `Position - ${metric_name}`,
          id: selectedPointName,
          yAxis: (isSeriesLine ? 1 : 0),
          xAxis: 0,
          type: (isSeriesLine ? 'spline' : 'column'),
          ...(
            isSeriesLine  && {
                marker: {
                lineWidth: 2,
                lineColor: '#000000',
                fillColor: '#FFFFFF'
              }
            }
          ),
          data: positions.map((position, index) => {
            const positionData = data.filter(item => item.player_id__position === position);
            const valueOf = (item) => item[`${metric_name}${suffix}`];
            let yVal = null;
            if (suffix.endsWith('avg')) {
              yVal = healthyMean(positionData, valueOf, injuredInGroup);
            } else if (suffix.endsWith('max')) {
              yVal = healthyMax(positionData, valueOf, injuredInGroup);
            } else if (suffix.endsWith('min')) {
              yVal = healthyMin(positionData, valueOf, injuredInGroup);
            } else if (suffix.endsWith('sum')) {
              yVal = healthySum(positionData, valueOf, injuredInGroup);
            }

            return {
              name: position,
              y: yVal === null ? null : Number(yVal.toFixed(decimal_places)),
              ...(enableDrillDown && {drilldown: position}),
              color: (isSeriesLine ? "#000000" : ELD_colors.bar[parseInt(seriesType[seriesType.length - 1], 10) - 1])
            };
          }),
        };
      })

      return{ drilldowns, positions };
    }
    
    if (levelNum == 2) { 
      // Third layer: Players
      let playerNames = new Set();
      positions.filter(pos => pos === selectedPointName).forEach((position) => {
        Object.entries(mapping).forEach(([seriesType, { metric_id, metric_name }], idx) => {
          const metric = metrics.filter(m => m.testing_metric_id === metric_id)[0];
          const decimal_places = metric?.num_decimals || 2;
          const suffix = getSuffixByStat(metric, stat);
          const isSeriesLine = (seriesType === "line");
           const playersData = data
            .filter(item => item.player_id__position === position)
            .map(player => {
              const playerName = drilldownPlayerLabel(player);
              if (!playerNames.has(playerName)) {
                playerNames.add(playerName);  
              }

              let yVal;
              if (suffix.endsWith('avg')) {
                yVal = player[`${metric_name}${suffix}`];
              } else if (suffix.endsWith('max')) {
                yVal = player.reps[metric_name].reduce((max, item) => Math.max(max, (Array.isArray(item) ? item[0] : item)), -Infinity);
              } else if (suffix.endsWith('min')) {
                yVal = player.reps[metric_name].reduce((min, item) => Math.min(min, (Array.isArray(item) ? item[0] : item)), Infinity);
              } else if (suffix.endsWith('sum')) {
                yVal = player.reps[metric_name].reduce((sum, item) => sum + (Array.isArray(item) ? item[0] : item), 0);
              }
              
              return {
                name: playerName,
                y: Number(yVal?.toFixed(decimal_places)),
                custom: { injured: injuredInGroup(player) },
                ...(enableDrillDown && {drilldown: playerName}),
                color: (isSeriesLine ? "#000000" : ELD_colors.bar[parseInt(seriesType[seriesType.length - 1], 10) - 1])
              };
            });
      
          drilldowns[metric_name] = {
            name: `Players - ${metric_name}`,
            id: selectedPointName,
            type: (isSeriesLine ? 'spline' : 'column'),
            ...(
              isSeriesLine  && {
                  marker: {
                  lineWidth: 2,
                  lineColor: '#000000',
                  fillColor: '#FFFFFF'
                }
              }
            ),
            xAxis: 0,
            yAxis: (isSeriesLine ? 1 : 0),
            data: playersData
          };

        });
       
      });

      return{ drilldowns, names: Array.from(playerNames) };
    }

    if (levelNum == 3) { 
      // Fourth layer: Player Reps
      let repNames = new Set();
      Object.entries(mapping).forEach(([seriesType, { metric_id, metric_name }], idx) => {
        const metric = metrics.filter(m => m.testing_metric_id === metric_id)[0];
        const decimal_places = metric?.num_decimals || 2;
        const isSeriesLine = (seriesType === "line");
        data.filter(i => {
          const playerName = drilldownPlayerLabel(i);
          if (playerName === selectedPointName) return i;
        }).forEach((item) => {
          const playerName = drilldownPlayerLabel(item);
          let playerRepsData = item.reps[metric_name].map((repVal, repIdx) => { 
            const repName = `Rep-${repIdx + 1}`;
            if (!repNames.has(repName)) {
              repNames.add(repName);  
            }

            return {
              name: repName,
              y: Number(repVal?.toFixed(decimal_places)),
              color: (isSeriesLine ? "#000000" : ELD_colors.bar[parseInt(seriesType[seriesType.length - 1], 10) - 1])
            };
          })
          
          drilldowns[metric_name] = {
            name: `Player Reps - ${metric_name}`,
            id: selectedPointName,
            type: (isSeriesLine ? 'spline' : 'column'),
            ...(
              isSeriesLine  && {
                  marker: {
                  lineWidth: 2,
                  lineColor: '#000000',
                  fillColor: '#FFFFFF'
                }
              }
            ),
            data: playerRepsData,
            xAxis: 0,
            yAxis: (isSeriesLine ? 1 : 0),
          };
        });

      });

      return{ drilldowns, repNames: Array.from(repNames) };
    }
  }
  
  return options;
}
